export default __webpack_public_path__ + "static/media/none.05284a02.png";